import API from "./API";

export default class DateWithoutTimeAPI extends API {
  constructor(parameters = {}) {
    super("/DateWithoutTime", parameters);
  }

  calculateMonthsCount(beginDate, endDate) {
    return this.submit("get", `${this.endpoint}/CalculateMonthsCount/beginDate=${beginDate}&endDate=${endDate}`);
  }

  addMonths(date, count) {
    return this.submit("get", `${this.endpoint}/AddMonths/date=${date}&count=${count}`);
  }

  addYearsBasedOnPerpetuity(date) {
    return this.submit("get", `${this.endpoint}/AddYearsBasedOnPerpetuity/${date}`);
  }

  getDatesInMont(month, year) {
    return this.submit("get", `${this.endpoint}/GetDatesInMonth/month=${month}&year=${year}`);
  }
}
